module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "8",
      "lg": "8"
    }
  }, [_c('duration-stage', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.DURATION.title,
      "items": _vm.DURATION.items,
      "total": _vm.DURATION.total,
      "filters": _vm.filtersItem
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#3F3FFF",
      "title": _vm.ACTIVATION.title,
      "previews": _vm.ACTIVATION.previews,
      "detail": _vm.ACTIVATION.detail,
      "fields": _vm.ACTIVATION.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.ACTIVATION.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#009688",
      "title": _vm.PAIRING.title,
      "previews": _vm.PAIRING.previews,
      "detail": _vm.PAIRING.detail,
      "fields": _vm.PAIRING.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.PAIRING.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#F44336",
      "title": _vm.CREATING.title,
      "previews": _vm.CREATING.previews,
      "detail": _vm.CREATING.detail,
      "fields": _vm.CREATING.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.CREATING.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#5F8CDC",
      "title": _vm.COMPLETE.title,
      "previews": _vm.COMPLETE.previews,
      "detail": _vm.COMPLETE.detail,
      "fields": _vm.COMPLETE.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.COMPLETE.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23769df8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/SpeedStages.vue
// module id = 2038
// module chunks = 0